module.exports = __webpack_public_path__ + "img/bois.9b09c9a4.png";